'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Period = require('./Period');

var _Period2 = _interopRequireDefault(_Period);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Period2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Period/index.js
// module id = 1213
// module chunks = 0